// Generated by purs version 0.15.0
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Network_JsonRPC from "../Network.JsonRPC/index.js";
import * as Restaumatic_Geocoding_RPC_Sites_Types from "../Restaumatic.Geocoding.RPC.Sites.Types/index.js";
import * as Restaumatic_Site_RPC from "../Restaumatic.Site.RPC/index.js";
var reverseGeocode = function (coordinates) {
    return Restaumatic_Site_RPC.sitesRPC(Network_JsonRPC.encodeRequest(Restaumatic_Geocoding_RPC_Sites_Types.encodeReverseGeocodeRequest)(Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Geocoding_RPC_Sites_Types.encodeReverseGeocodeRequest)))(Network_JsonRPC.decodeResponse(Restaumatic_Geocoding_RPC_Sites_Types.decodeReverseGeocodeResponse))(Restaumatic_Geocoding_RPC_Sites_Types.rpcMethodNameReverseGeocodeRequest)({
        coordinates: coordinates
    });
};
export {
    reverseGeocode
};
//# sourceMappingURL=index.js.map
